import React, {useState, useEffect} from 'react'
import '../addStock.css'

const PackUnitInput = (props: any) => {
  const { row, column, table , getValue}= props.props;

  const packUnitOptions = ['SELECT','ML', 'MG', 'KG', 'Strip', 'LTR', 'OTHERS']
  const [selectedValue, setSelectedValue] = useState(getValue() !== ''?getValue() :null)


  const handleChange = (event: any) => {
    const value = event.target.value
    setSelectedValue(value)
  }

  const onBlur = ()=>{
    table.options.meta?.updateData(row.index,column.id,selectedValue);
  }

  return (
    <div className='input-group'>
    <select className='table-input' value={selectedValue} onChange={handleChange} onBlur={()=>onBlur()}>
      {packUnitOptions.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
    </div>
  )
}

export default PackUnitInput
